import fulfillmentPlan from "./fulfillmentPlan.component";
import fulfillmentPlanUrls from "./fulfillmentPlan.urls";
import FulfillmentPlanTransforms from "./fulfillmentPlan.transforms";

const fulfillmentPlanModule = angular
  .module("app.components.fulfillmentPlan", [])
  .component("fulfillmentPlanPage", fulfillmentPlan)
  .service("FulfillmentPlanTransforms", FulfillmentPlanTransforms)
  .config(fulfillmentPlanUrls);

export default fulfillmentPlanModule;



// WEBPACK FOOTER //
// ./src/pages/fulfillmentPlan/fulfillmentPlan.module.js